<div class="inspection-container py-4 mb-5 hide-on-print">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h3 class="fw-bold mb-0 text-dark"><i class="bi bi-clipboard-check me-2 text-primary"></i>Inspección técnica</h3>
      <p class="text-muted mb-0">Revisión multipuntos y mapeo 3D de daños para la orden: <strong *ngIf="workOrder">{{ workOrder.caseNumber }}</strong></p>
    </div>
    <div class="d-flex gap-2">
      <button class="btn btn-outline-secondary shadow-sm" (click)="goBack()"><i class="bi bi-arrow-left me-1"></i>Volver</button>
      <button class="btn btn-dark shadow-sm" (click)="printInspection()"><i class="bi bi-printer me-1"></i>Imprimir reporte</button>
      <button class="btn btn-primary shadow-sm" (click)="saveInspection()" [disabled]="isSaving || isLoading">
        <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1"></span>
        <i class="bi bi-save me-1" *ngIf="!isSaving"></i>Guardar inspección
      </button>
    </div>
  </div>

  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border text-primary"></div>
  </div>

  <div *ngIf="!isLoading" class="row g-4">
    
    <!-- COLUMNA IZQUIERDA: Formulario Técnico -->
    <div class="col-lg-6">
      <form [formGroup]="inspectionForm">
        
        <!-- Batería E-Bike -->
        <div class="card border-0 shadow-sm rounded-4 mb-4">
          <div class="card-header bg-white border-bottom py-3">
            <h6 class="mb-0 fw-bold"><i class="bi bi-lightning-charge-fill text-warning me-2"></i>Sistema eléctrico y batería (E-Bikes)</h6>
          </div>
          <div class="card-body row g-3">
            <div class="col-4">
              <label class="form-label small text-muted">Salud de Batería (%)</label>
              <input type="number" class="form-control bg-light" formControlName="batteryHealthPct" placeholder="Ej: 100">
            </div>
            <div class="col-4">
              <label class="form-label small text-muted">Ciclos de Carga</label>
              <input type="number" class="form-control bg-light" formControlName="batteryChargeCycles" placeholder="Ej: 45">
            </div>
            <div class="col-4">
              <label class="form-label small text-muted">Estado del Sistema</label>
              <select class="form-select bg-light" formControlName="batteryStatus">
                <option value="">Seleccione...</option>
                <option value="Verde">Óptimo</option>
                <option value="Amarillo">Regular</option>
                <option value="Rojo">Revisión Requerida</option>
                <option value="N/A">N/A</option>
              </select>
            </div>
          </div>
        </div>

        <!-- Desgaste de Llantas y Frenos (2 Ruedas) -->
        <div class="card border-0 shadow-sm rounded-4 mb-4">
          <div class="card-header bg-white border-bottom py-3">
            <h6 class="mb-0 fw-bold"><i class="bi bi-vinyl-fill text-dark me-2"></i>Desgaste de Neumáticos y Frenos</h6>
          </div>
          <div class="card-body">
            <p class="small text-muted mb-3">Indique el porcentaje de vida útil restante o milímetros de desgaste.</p>
            <div class="row g-3">
              <!-- Rueda Delantera -->
              <div class="col-6">
                <div class="p-3 border rounded bg-light">
                  <small class="d-block fw-bold mb-2 text-center text-uppercase">Rueda Delantera</small>
                  <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text bg-white text-muted" style="width: 80px;">Neumático</span>
                    <input type="text" class="form-control text-center fw-bold" formControlName="tireFront" placeholder="% o mm">
                  </div>
                  <div class="input-group input-group-sm">
                    <span class="input-group-text bg-white text-muted" style="width: 80px;">Pastillas</span>
                    <input type="text" class="form-control text-center fw-bold" formControlName="brakePadFront" placeholder="% o mm">
                  </div>
                </div>
              </div>
              <!-- Rueda Trasera -->
              <div class="col-6">
                <div class="p-3 border rounded bg-light">
                  <small class="d-block fw-bold mb-2 text-center text-uppercase">Rueda Trasera</small>
                  <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text bg-white text-muted" style="width: 80px;">Neumático</span>
                    <input type="text" class="form-control text-center fw-bold" formControlName="tireRear" placeholder="% o mm">
                  </div>
                  <div class="input-group input-group-sm">
                    <span class="input-group-text bg-white text-muted" style="width: 80px;">Pastillas</span>
                    <input type="text" class="form-control text-center fw-bold" formControlName="brakePadRear" placeholder="% o mm">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Puntos de revisión generados dinámicamente -->
        <ng-container formGroupName="checks">
          <div *ngFor="let cat of checkCategories" class="card border-0 shadow-sm rounded-4 mb-4">
            <div class="card-header bg-white border-bottom py-3 d-flex justify-content-between align-items-center">
              <h6 class="mb-0 fw-bold">{{ cat.title }}</h6>
              <span class="badge bg-light text-muted border">Trabajado</span>
            </div>
            <div class="card-body p-0">
              <table class="table table-hover align-middle mb-0">
                <tbody>
                  <tr *ngFor="let item of cat.items" [formGroupName]="item.id">
                    <td class="ps-3 small fw-semibold text-muted w-50">{{ item.label }}</td>
                    <td class="w-25">
                      <select class="form-select form-select-sm bg-light border-0" formControlName="status">
                        <option value="">No evaluado</option>
                        <option value="Ok">Ok</option>
                        <option value="Desgaste">Desgaste</option>
                        <option value="Cambiar/reparar">Cambiar / Reparar</option>
                      </select>
                    </td>
                    <td class="text-center pe-3" style="width: 15%;">
                      <div class="form-check d-flex justify-content-center mb-0">
                        <input class="form-check-input shadow-sm border-secondary" type="checkbox" formControlName="repaired" title="Marcar si el elemento fue reparado">
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-container>

        <div class="card border-0 shadow-sm rounded-4 mb-4">
          <div class="card-body">
            <label class="form-label small fw-bold text-muted">Notas y recomendaciones técnicas</label>
            <textarea class="form-control bg-light border-0" rows="4" formControlName="generalNotes"></textarea>
          </div>
        </div>

      </form>
    </div>

    <!-- COLUMNA DERECHA: Mapeo 3D de Carrocería (Cuadro) -->
    <div class="col-lg-6">
      <div class="card border-0 shadow-sm rounded-4 h-100 overflow-hidden sticky-top" style="top: 20px; z-index: 10;">
        <div class="card-header bg-dark text-white py-3 d-flex justify-content-between align-items-center">
          <h6 class="mb-0 fw-bold"><i class="bi bi-bicycle me-2"></i>Mapeo 3D de Cuadro y Componentes</h6>
          <small class="text-white-50"><i class="bi bi-info-circle me-1"></i>Haga clic para añadir daño</small>
        </div>
        <div class="card-body p-0 position-relative bg-secondary bg-opacity-10 d-flex flex-column">
          
          <model-viewer 
            #bikeModel
            src="assets/bike.glb" 
            alt="Modelo 3D de Bicicleta"
            camera-controls
            auto-rotate
            interaction-prompt="none"
            style="width: 100%; height: 500px; background-color: #e9ecef;"
            (click)="onModelClick($event)">
            
            <button *ngFor="let mark of damageMarkers; let i = index"
                    class="damage-hotspot"
                    [attr.slot]="'hotspot-' + i" 
                    [attr.data-position]="mark.position" 
                    [attr.data-normal]="mark.normal">
              <div class="hotspot-annotation shadow">
                <strong>{{ mark.part }}</strong><br>
                {{ mark.damage }}
              </div>
            </button>

          </model-viewer>

          <div class="p-3 bg-white border-top flex-grow-1">
            <h6 class="fw-bold small text-muted text-uppercase mb-3">Registro de daños e impactos en cuadro</h6>
            <div class="table-responsive" style="max-height: 200px;">
              <table class="table table-sm align-middle">
                <tbody>
                  <tr *ngFor="let mark of damageMarkers">
                    <td class="text-danger"><i class="bi bi-x-circle-fill"></i></td>
                    <td class="fw-bold text-dark">{{ mark.part }}</td>
                    <td class="text-muted">{{ mark.damage }}</td>
                    <td class="text-end">
                      <button class="btn btn-sm text-danger p-0" (click)="removeMarker(mark.id)"><i class="bi bi-trash"></i></button>
                    </td>
                  </tr>
                  <tr *ngIf="damageMarkers.length === 0">
                    <td colspan="4" class="text-center text-muted small py-3 fst-italic">El cuadro y componentes no presentan daños físicos registrados.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>

<!-- ========================================== -->
<!-- PLANTILLA DE IMPRESIÓN (OCULTA EN PANTALLA)-->
<!-- ========================================== -->
<div class="print-only" *ngIf="workOrder">
  <div class="print-header">
    <img src="assets/logo.png" alt="ServiTrack" style="height: 40px; filter: grayscale(100%);">
    <h2>Reporte de Inspección Técnica</h2>
    <p>Revisión multipuntos de bicicleta y mapeo de daños del cuadro</p>
  </div>
  
  <div class="print-section">
    <table>
      <tr>
        <td><strong>Orden #:</strong> {{ workOrder!.caseNumber }}</td>
        <td><strong>Fecha:</strong> {{ workOrder!.entryDate?.toDate() | date:'dd/MM/yyyy' }}</td>
      </tr>
      <tr>
        <td><strong>Cliente:</strong> {{ workOrder!.clientName }}</td>
        <td><strong>Bicicleta:</strong> {{ workOrder!.bikeDescription }}</td>
      </tr>
    </table>
  </div>

  <div class="print-section">
    <h3>Neumáticos y Pastillas de Freno (Vida útil o mm)</h3>
    <table>
      <tr>
        <th>Posición</th>
        <th>Desgaste de Neumático</th>
        <th>Estado Pastillas</th>
      </tr>
      <tr>
        <td>Rueda Delantera</td>
        <td>{{ inspectionForm.value.tireFront || 'N/A' }}</td>
        <td>{{ inspectionForm.value.brakePadFront || 'N/A' }}</td>
      </tr>
      <tr>
        <td>Rueda Trasera</td>
        <td>{{ inspectionForm.value.tireRear || 'N/A' }}</td>
        <td>{{ inspectionForm.value.brakePadRear || 'N/A' }}</td>
      </tr>
    </table>
  </div>

  <div class="print-section">
    <h3>Detalle de Inspección Técnica</h3>
    <table>
      <thead>
        <tr>
          <th>Punto de revisión</th>
          <th>Estado reportado</th>
          <th style="text-align: center;">Servicio Realizado</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let cat of checkCategories">
          <tr><td colspan="3" class="bg-gray"><strong>{{ cat.title }}</strong></td></tr>
          <tr *ngFor="let item of cat.items">
            <td>{{ item.label }}</td>
            <td>{{ inspectionForm.value.checks[item.id]?.status || 'No evaluado' }}</td>
            <td style="text-align: center;">{{ inspectionForm.value.checks[item.id]?.repaired ? 'Sí' : 'No' }}</td>
          </tr>
        </ng-container>
        
        <tr><td colspan="3" class="bg-gray"><strong>Sistema Eléctrico (E-Bikes)</strong></td></tr>
        <tr>
          <td>Salud / Ciclos</td>
          <td colspan="2">
            Salud: {{ inspectionForm.value.batteryHealthPct || 'N/A' }}% | 
            Ciclos: {{ inspectionForm.value.batteryChargeCycles || 'N/A' }} | 
            Estado: {{ inspectionForm.value.batteryStatus || 'No evaluado' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="print-section" *ngIf="damageMarkers.length > 0">
    <h3>Registro de Daños de Cuadro y Componentes</h3>
    <table>
      <tr>
        <th>Parte afectada</th>
        <th>Descripción del daño físico reportado</th>
      </tr>
      <tr *ngFor="let mark of damageMarkers">
        <td>{{ mark.part }}</td>
        <td>{{ mark.damage }}</td>
      </tr>
    </table>
  </div>

  <div class="print-section">
    <h3>Observaciones del Técnico</h3>
    <p class="notes-box">{{ inspectionForm.value.generalNotes || 'Sin observaciones adicionales registradas.' }}</p>
  </div>

  <div class="print-signatures">
    <div class="sig-line">Firma del Mecánico Principal</div>
    <div class="sig-line">Firma del Cliente (Aceptación)</div>
  </div>
</div>